import { render } from "./OpenInvoicesPage.vue?vue&type=template&id=456c664e&scoped=true"
import script from "./OpenInvoicesPage.vue?vue&type=script&lang=js"
export * from "./OpenInvoicesPage.vue?vue&type=script&lang=js"

import "./OpenInvoicesPage.vue?vue&type=style&index=0&id=456c664e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456c664e"]])

export default __exports__